// Topics.js
import React, { useEffect, useState } from "react";
import Input from "../../CoreComponent/Input";
import SVG from "react-inlinesvg";
import deleteIcon from "../../icons/deleteIcon.svg";

const Topics = ({
  topics = [],
  handleTopicChange,
  handleRemoveTopic,
  handleAddTopic,
}) => {
  const [approvedTopics, setApprovedTopics] = useState([]);

  useEffect(() => {
    const fetchSpeakerInfoAndTopics = async () => {
      const token = localStorage.getItem("token");

      try {
        // 1. Fetch speaker info
        const speakerResponse = await fetch(
          "https://eventscons.com/eventbackendnew/api/speakers/info",
          {
            headers: {
              Authorization: `Bearer ${token}`,
              Accept: "application/json",
            },
          }
        );

        const speakerData = await speakerResponse.json();
        console.log("Speaker Info API Response:", speakerData);

        if (speakerData.speaker) {
          const { speaker_id, user_id, speaker_conference_id } = speakerData.speaker || {};

          if (speaker_id && user_id && speaker_conference_id) {
            // 2. Fetch ALL topics using the new dynamic API endpoint
            const topicsResponse = await fetch(
              `https://eventscons.com/eventbackendnew/api/speakertopics?speaker_id=${speaker_id}&user_id=${user_id}&conference_id=${speaker_conference_id}`,
              {
                headers: {
                  Authorization: `Bearer ${token}`,
                  Accept: "application/json",
                },
              }
            );

            const topicsResult = await topicsResponse.json();
            console.log("All Topics API Response:", topicsResult);

            if (topicsResult.status && Array.isArray(topicsResult.data)) {
              setApprovedTopics(topicsResult.data);
            } else {
              console.error("Topics API Error:", topicsResult.message || "Something went wrong");
              setApprovedTopics([]); // Clear topics on error
            }
          } else {
            console.error("Speaker ID, User ID, or Conference ID not found.");
            setApprovedTopics([]);
          }
        } else {
          console.error("Speaker Info Error:", speakerData.message || "Something went wrong");
          setApprovedTopics([]);
        }
      } catch (error) {
        console.error("Fetch Error:", error.message);
        setApprovedTopics([]);
      }
    };

    fetchSpeakerInfoAndTopics();
  }, []);

  return (
    <div style={{ padding: "20px", border: "1px solid #eee", borderRadius: "8px" }}>
      {/* All Topics Section */}
      {approvedTopics.length > 0 ? (
        <div style={{ marginBottom: "24px" }}>
          <div style={{ fontSize: "18px", fontWeight: "bold", marginBottom: "12px", color: "#333" }}>
            Topics:
          </div>
          <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
            {approvedTopics.map((topicObj, idx) => (
              <div
                key={idx}
                style={{
                  border: "1px solid #d2d2d2",
                  borderLeft: `5px solid ${topicObj.status === 'approved' ? '#4caf50' : topicObj.status === 'pending' ? '#ff9800' : '#f44336'}`,
                  padding: "12px 16px",
                  borderRadius: "8px",
                  backgroundColor: topicObj.status === 'approved' ? '#f9fff9' : topicObj.status === 'pending' ? '#fff8e1' : '#ffebee',
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <span style={{ fontWeight: 500, color: "#222" }}>{topicObj.topic_name}</span>
                {topicObj.status && (
                  <span
                    style={{
                      fontSize: "12px",
                      fontWeight: "bold",
                      padding: "4px 8px",
                      borderRadius: "20px",
                      backgroundColor: 
                        topicObj.status === 'approved' ? '#e6f4ea' : 
                        topicObj.status === 'pending' ? '#fff3cd' : 
                        '#f8d7da',
                      color: 
                        topicObj.status === 'approved' ? '#2e7d32' : 
                        topicObj.status === 'pending' ? '#856404' : 
                        '#721c24',
                      border: `1px solid ${
                        topicObj.status === 'approved' ? '#2e7d32' : 
                        topicObj.status === 'pending' ? '#856404' : 
                        '#721c24'
                      }`,
                    }}
                  >
                    {topicObj.status.charAt(0).toUpperCase() + topicObj.status.slice(1)}
                  </span>
                )}
              </div>
            ))}
          </div>
        </div>
      ) : (
        <div style={{ textAlign: "center", color: "#666", padding: "20px" }}>
          No topics found
        </div>
      )}
    </div>
  );
};

export default Topics;
